export default function NavigationCard({ label, onClick, icon: Icon }) {
  return (
    <div
      className="group border border-purple-800/60 bg-purple-950/20 rounded-lg h-24 w-full cursor-pointer hover:bg-purple-900/40 hover:border-purple-500 hover:-translate-y-1 hover:shadow-lg hover:shadow-purple-900/50 transition-all duration-200 flex flex-col items-center justify-center text-center p-2 gap-1"
      onClick={onClick}
    >
      {Icon && (
        <Icon
          size={22}
          className="text-purple-400 group-hover:text-purple-200 transition-colors"
        />
      )}
      <span className="text-sm sm:text-base">{label}</span>
    </div>
  );
}
